/**
 * Automated campaigns utilities
 */

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
  });
};

export const DISCOUNT_OPTIONS = [5, 10, 15];

export const INACTIVE_DAYS_OPTIONS = [
  { value: 30, label: '30 days inactive' },
  { value: 45, label: '45 days inactive' },
  { value: 60, label: '60 days inactive' },
  { value: 90, label: '90 days inactive' },
];

export const SEND_TIMING_OPTIONS = [
  { value: 0, label: 'On birthday' },
  { value: 1, label: '1 day before' },
  { value: 3, label: '3 days before' },
  { value: 7, label: '1 week before' },
];

export const MAX_SENDS_OPTIONS = [
  { value: 1, label: '1 time only' },
  { value: 2, label: 'Up to 2 times' },
  { value: 3, label: 'Up to 3 times' },
];
